/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'reactstrap';
import { StateContext } from '../../State';
import Input from '../../Components/Input/Input';
import Button from '../../Components/Button/Button';
import { addSection, updateSection } from '../../Service/Api';

class SectionForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            createMode: true,
            data: {},
            errors: {},
        };
        this.handleCreate = this.handleCreate.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.onChange = this.onChange.bind(this);
        this.validForm = this.validForm.bind(this);
    }

    componentDidMount() {
        const { data } = this.props;
        if (data) {
            this.setState({
                data,
                createMode: false,
            });
        }
    }

    onChange(event) {
        const { name, value } = event.target;
        const { data, errors } = this.state;
        data[name] = value;
        errors[name] = '';
        this.setState({
            data,
            errors,
        });
    }

    handleError = (error) => {
        const { status } = error.response;
        if (status === 401 || status === 403) {
            const [, dispatch] = this.context;
            dispatch({
                type: 'EXIT',
            });
        } else {
            this.setState({
                errors: error.response.data.errors,
            });
        }
    }

    validForm() {
        const { data } = this.state;
        const { name } = data;
        const errors = {};
        let formIsValid = true;

        if (!name || name.trim().length === 0) {
            formIsValid = false;
            errors.name = 'Requerido';
        }

        this.setState({
            errors,
        });

        return formIsValid;
    }

    async handleCreate() {
        if (this.validForm()) {
            this.toggleLoading(true);
            const { data } = this.state;
            const { form_id } = this.props;
            await addSection(data, form_id).then((response) => {
                if (response && response.status === 200) {
                    const { callback, history } = this.props;
                    if (response.data.id === form_id) {
                        callback();
                    } else {
                        history.push(`/admin/formularios/${response.data.id}`);
                    }
                }
            }).catch((error) => {
                this.handleError(error);
            });

            this.toggleLoading(false);
        }
    }

    async handleUpdate() {
        const { history } = this.props;
        if (this.validForm()) {
            this.toggleLoading(true);
            const { data } = this.state;
            await updateSection(data, data.id)
                .then((response) => {
                    if (response && response.status === 200) {
                        history.push(`/admin/formularios/${response.data.id}`);
                    }
                }).catch(() => {
                    const { callback } = this.props;
                    callback();
                });

            this.toggleLoading(false);
        }
    }

    toggleLoading(value) {
        this.setState({
            loading: value,
        });
    }

    render() {
        const {
            createMode, errors, data, loading,
        } = this.state;
        const { name } = data;

        return (
            <>
                <Input name="name" onChange={this.onChange} label="Nombre" placeholder="Nombre de sección" value={name} errors={errors} required />
                <div className="form-footer">
                    {loading && <div className="spinner"><Spinner /></div>}
                    <Button text={createMode ? 'Crear' : 'Actualizar'} onClick={createMode ? this.handleCreate : this.handleUpdate} />
                </div>
            </>
        );
    }
}

SectionForm.propTypes = {
    callback: PropTypes.func,
    data: PropTypes.object,
    form_id: PropTypes.number.isRequired,
};

SectionForm.defaultProps = {
    callback: null,
    data: null,
};

SectionForm.contextType = StateContext;

export default SectionForm;
